import DetailViewContentElement from "../../../common/models/detailView/elements/detailViewContentElement";

export class TabBreak extends DetailViewContentElement {
  static placeholder(index) {
    return `Tab ${index + 1}`;
  }

  initializeAfterParentSet(): this {
    this.parent.buildTab();
    return this;
  }

  destroy(nameIndex?: number): void {
    this.parent.destroyTab(nameIndex);
    super.destroy();
  }

  get index(): number {
    return this.parent.tabBreaks.indexOf(this);
  }

  get priorTabContentElementsStartIndex(): number {
    const index = this.index;
    if (index === 0) {
      return 0
    } else {
      let priorTabBreak = this.parent.tabBreaks[index - 1];
      return this.parent.contentElementsArray.indexOf(priorTabBreak);
    }
  }

  get priorTabContentElementsEndIndex(): number {
    return this.parent.contentElementsArray.indexOf(this);
  }

  get nextTabContentElementsStartIndex(): number {
    return this.priorTabContentElementsEndIndex;
  }

  get nextTabContentElementsEndIndex(): number {
    const nextTabBreak = this.parent.tabBreaks[this.index + 1];
    if (!!nextTabBreak){
      return this.parent.contentElementsArray.indexOf(nextTabBreak);
    }else{
      return this.parent.contentElementsArray.length-1;
    }
  }

  get priorTab(): string {
    return this.parent.tabs[this.index] || TabBreak.placeholder(this.index);
  }

  get nextTab(): string {
    return this.parent.tabs[this.index + 1] || TabBreak.placeholder(this.index + 1);
  }
}